import script from "./BrandWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandWidget.vue?vue&type=script&setup=true&lang=js"

import "./BrandWidget.vue?vue&type=style&index=0&id=4b36ba83&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b36ba83"]])

export default __exports__